// 0058: to-do's in de ouderapp (Taken → To-do, en de taak-editor). Een to-do heeft geen datum of
// tijd en blijft staan tot hij af is; een ouder kan hem voor iedereen maken ("van Anne").
export const appTodoNl = {
    /** Tab in Taken. */
    tab: "To-do's",
    /** Keuze bij "Hoe vaak" in de taak-editor. */
    repeatOption: 'Zonder datum (to-do)',
    repeatHint: 'Geen datum of tijd. De to-do blijft staan tot hij af is.',
    description: 'Uitleg (optioneel)',
    dueDate: 'Uiterlijk (optioneel)',
    dueClear: 'Geen einddatum',
    from: 'van {name}',
    due: 'uiterlijk {date}',
    emptyTitle: "Geen to-do's",
    emptyBody: 'Een to-do heeft geen datum of tijd en blijft staan tot hij af is. Bijvoorbeeld: de schoenenkast verven.',
    add: 'To-do toevoegen',
    /** Kopje boven wat de laatste 30 dagen af is. */
    doneSection: 'Klaar',
    doneOn: 'af op {date}',
    newTitle: 'Nieuwe to-do',
    editTitle: 'To-do wijzigen',
    important: 'Belangrijk',
    importantHint: 'Staat bovenaan, met een klein teken.',
    assign: 'Toewijzen aan',
    assignHint: "Baby's en peuters krijgen geen to-do.",
    assigned: 'Toegewezen aan {names}',
    // Oprichter 6 okt: privé to-do's in Mijn omgeving en de kaart op Vandaag.
    privateNote: "Alleen jij ziet deze to-do's. Het gezin en het bord niet. Op het bord komt alleen iets als je dat zelf per tablet uitdrukkelijk bevestigt; dat kun je altijd weer weghalen.",
    privateEntry: 'Privé to-do? Maak hem in Mijn omgeving. Daar ziet alleen jij hem.',
    privateEntryButton: 'Naar Mijn omgeving',
    gateTitle: "Je eigen to-do's",
    gateBody: "Je eigen to-do's staan in Mijn omgeving. Alleen jij ziet ze: het gezin en het bord niet. Op het bord komt alleen iets als je dat zelf per tablet uitdrukkelijk bevestigt; dat kun je altijd weer weghalen.",
    gateOpen: 'Open Mijn omgeving',
    gateOpening: 'Even openen…',
    widgetEmpty: "Geen open to-do's.",
    widgetAll: "Alle to-do's",
    widgetMore: '+{count} meer',
    widgetFrom: 'Van {name}, alleen lezen',
    widgetOpenIn: 'Open in {name}',
    widgetPending: 'Wacht op goedkeuring',
};
//# sourceMappingURL=todoApp.nl.js.map